<div class="flex-column gap-S">
	<div class="flex-align-center flex-space-between">
		<div class="flex-align-center gap-S">
			<div class="font-MM fw-700">{{ 'page.infrastructure.network.routersLinked' | translate }}</div>
		</div>
		<app-button-widget [disabled]="!isEditor" (onClick)="openLinkRoutersToNetwork()" [tooltip]="'readOnly.buttonTooltip' | translate" [tooltipDisabled]="isEditor" tooltipPosition="left">
			<img *ngIf="isEditor" width="12" src="assets/icons/add.svg" class="filter-primary" alt="">
			<img *ngIf="!isEditor" width="15" src="assets/icons/lock-01.svg">
		</app-button-widget>
	</div>
	@for (router of routers; let i = $index; track router.router.id) {
		<div class="server-card">
			<div (click)="goToRouter(router.router.id)"
				 class="pl-s pr-m pt-s pb-s flex-space-between flex-align-center gap-S c-p">
				<div class="flex-align-center c-p" style="gap: 60px">
					<div style="user-select: none" class="flex-center gap-S">
						<app-router-icon [size]="38" [router]="router.router"></app-router-icon>
						<div class="flex-justify-center flex-column gap-XS" style="width: 130px">
							<div class="text-overflow-ellipsis font-M fw-700">
								{{ router.router.name }}
							</div>
							<div class="text-overflow-ellipsis font-S">
								{{ 'page.infrastructure.router.' + router.router.type.toLowerCase() | translate }}
							</div>
						</div>
					</div>
					<app-popup-text-input *ngIf="!router.routerInterface && isEditor" class="w-100 network-interface" [control]="getInterfaceControlAt(i)"
										  (click)="$event.stopPropagation()"
										  (confirm)="updateRouterNetworkInterface(router.router.id, i)">
						@if (!router.routerInterface) {
							<div popup-trigger class="add-interface-chip flex-align-center" style="padding-left: 12px; padding-right: 18px; gap: 6px;">
								<img src="assets/icons/add.svg" height="10px" alt="">
								<span class="font-M fw-500">{{ 'page.infrastructure.addInterface' | translate }}</span>
							</div>
						} @else {
							<app-popup-trigger class="w-100">{{ router.routerInterface }}</app-popup-trigger>
						}
					</app-popup-text-input>
					<div *ngIf="router.routerInterface" [tooltip]="'page.infrastructure.interfaceTooltip' | translate" tooltipPosition="bottom" [tooltipOffset]="5" class="add-interface-chip network-interface flex-align-center gap-S p-relative" style="padding-left: 12px; padding-right: 18px; cursor: default">
						<div class="flex-align-center" style="gap: 6px;" (click)="$event.stopPropagation();">
							<img src="assets/icons/network-interface.svg">
							<span>{{ router.routerInterface }}</span>
						</div>
						<div *ngIf="isEditor" style="right: -4px; top: -4px" class="remove-interface-button flex-center c-p p-absolute" (click)="$event.stopPropagation();resetRouterInterface(router.router.id)">
							<img src="assets/icons/close.svg" width="7" class="filter-white">
						</div>
					</div>
				</div>
				<div class="flex-align-center gap-XL">
					<div style="margin-left: auto">
						<div class="disp-f justify-center a-i-c">
							<img src="assets/icons/arrow-right.svg">
						</div>
					</div>
				</div>
			</div>
		</div>
	} @empty {
		<div class="w-100 flex-center flex-column" style="height: 280px;">
			<img src="../../../../../../../../assets/illustrations/empty-networks.svg" width="300">
			<span class="grey">{{ 'page.infrastructure.network.noRouterAttached' | translate }}</span>
		</div>
	}
</div>
